<h1>Steal Like An Artist #genuary6</h1>

<p>
  This is about submission, terror, insubordination, alignment. Notice how some
  people are not properly aligned, while some other are missing. It is heavily
  inspired by, and a tribute to the work on terror by León Ferrari, e.g., mesas
  tables.
</p>

<img src="../genuary/img/06/1.png" alt="genuary6 by Pandelune" />

<p></p>

León Ferrari, the Architecture of Madness:
<img
  src="../genuary/img/06/Ferrari the Architecture of Madness.jpg"
  alt="León Ferrari, the Architecture of Madness"
/>
